import $ from "jquery";

const NAME_REG = /(^[A-Za-z]{3,16})([ ]{0,1})([A-Za-z]{3,16})?([ ]{0,1})?([A-Za-z]{3,16})?([ ]{0,1})?([A-Za-z]{3,16})/;
const EMAIL_REG = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
const ADDRESS_REG = /^(\d+) ?([A-Za-z](?= ))? (.*?) ([^ ]+?) ?((?<= )APT)? ?((?<= )\d*)?$/;
const PHONE_NUMBER_REG = /((\(\d{3}\) ?)|(\d{3}-))?\d{3}-\d{4}/;
const POSTAL_CODE_REG = /^\d{5}-\d{4}|\d{5}|[A-Z]\d[A-Z] \d[A-Z]\d$/;
const URL_REG = /(https?:\/\/)?([\w\-])+\.{1}([a-zA-Z]{2,63})([\/\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)/;
const ONLY_LETTER_REG = /^[a-zA-Z\s]*$/;
const ONLY_NUMBER_REG = /^[0-9]*$/;

const MESSAGE_REQUIRED = 'This field is required.';
const MESSAGE_ONLY_LETTER = 'This field only allow letters.';
const MESSAGE_ONLY_NUMBER = 'This field only allow numbers.';

class BaseForm {
    constructor() {
        this.valid = true
    }

    initValidationFields = () => {

    }

    onlyAllowLetter = (e) => {
        const keyCode = e.keyCode || e.which;

        return ONLY_LETTER_REG.test(String.fromCharCode(keyCode));
    }

    onlyAllowNumber = (e) => {
        const keyCode = e.keyCode || e.which;

        return ONLY_NUMBER_REG.test(String.fromCharCode(keyCode));
    }

    assignElementOnlyAllowLetter = ($element) => {
        $element.on('keypress', this.onlyAllowLetter);
    }

    assignElementOnlyAllowNumber = ($element) => {
        $element.on('keypress', this.onlyAllowNumber);
    }

    afterValidate = (valid) => {

    }

    validateForm = () => {
        const $errors = $('.get-involved-form-error');
        let errors = 0;

        if ($errors)
            $errors.remove();

        for (const keyFieldValidation in this.fieldsValidation) {
            if (!this.fieldsValidation.hasOwnProperty(keyFieldValidation))
                continue;

            const fieldValidation = this.fieldsValidation[keyFieldValidation];


            let val = '';

            switch (fieldValidation.type) {
                case 'text':
                case 'textarea':
                    fieldValidation.$field.removeClass('error');

                    if (!fieldValidation.$field.data('keyup-valid')) {
                        fieldValidation.$field.data('keyup-valid', true)
                                       .on('keyup', () => this.validateForm());
                    }
                    val = fieldValidation.$field.val().trim();
                    break;
                case 'checkbox':
                    if (!fieldValidation.$field.data('checkout-valid')) {
                        fieldValidation.$field.data('checkout-valid', true)
                                       .on('change', () => this.validateForm());
                    }

                    val = fieldValidation.$field.is(':checked');
                    break;
            }

            for (const rule of fieldValidation.rules) {

                switch (true) {
                    case rule.hasOwnProperty('required') && rule.required && val === '':
                    case rule.hasOwnProperty('regex') && rule.regex && !rule.regex.test(val):
                        fieldValidation.$field.parent().append(
                            `<p class="error get-involved-form-error">${rule.message}</p>`
                        );
                        fieldValidation.$field.addClass('error');
                        errors++;
                        break;

                    case rule.hasOwnProperty('checked') && rule.checked && !val:
                        fieldValidation.$field.closest('.form-element').append(
                            `<p class="error get-involved-form-error">${rule.message}</p>`
                        );
                        fieldValidation.$field.addClass('error');
                        errors++;
                        break;
                }
            }
        }

        this.valid = errors === 0;

        this.afterValidate(this.valid);

        return this.valid;
    }
}

export {
    BaseForm,
    NAME_REG,
    EMAIL_REG,
    ADDRESS_REG,
    PHONE_NUMBER_REG,
    POSTAL_CODE_REG,
    URL_REG,
    ONLY_LETTER_REG,
    ONLY_NUMBER_REG,

    MESSAGE_REQUIRED,
    MESSAGE_ONLY_LETTER,
    MESSAGE_ONLY_NUMBER,
};